/** Stored prefixes win; the fallback is the first meaningful name word. */
export function normalizeInvoicePrefix(value: string): string | null {
  const prefix = value.trim().toUpperCase();
  return /^[A-Z0-9]{2,8}$/.test(prefix) ? prefix : null;
}

export function suggestedClientInvoicePrefix(name: string, fallback = "CLIENT"): string {
  const words = name.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").split(/\s+/);
  const first = words.map(word => word.replace(/[^A-Za-z0-9]/g, "")).find(word => word.length >= 2);
  return (first ?? fallback).slice(0, 8).toUpperCase();
}

/** Managed Invoice numbers use a four-digit account sequence, even when the prefix ends in digits. */
export function invoiceNumberSequence(number: string): number | null {
  const match = number.match(/(\d{4})$/);
  return match ? Number(match[1]) : null;
}

export function composeInvoiceNumber(prefix: string, sequence: number): string {
  if (!Number.isSafeInteger(sequence) || sequence < 1 || sequence > 9999) throw new Error("Invoice number sequence is exhausted");
  return `${prefix}${String(sequence).padStart(4, "0")}`;
}

export function clientInvoicePrefix(client: { displayName: string; invoicePrefix?: string | null }): string {
  return client.invoicePrefix ?? suggestedClientInvoicePrefix(client.displayName);
}
